import request from "@/utils/request";

export async function apiCheckLogin() {
    return request({url: '/passport/checkLogin', method: 'post'});
}

export async function apiGetLoginInfo() {
    return request({url: '/enterprise/loginInfo', method: 'get'});
}